export function ApprovalConsiderationAnnounceElevenComponent() {
    return (
        <>ประกาศ 7</>
    )
}